import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button, Form, Modal, Alert, Table, Dropdown, DropdownButton  } from "react-bootstrap";
import { ExclamationCircle, PlusCircle, ToggleOn, ToggleOff} from 'react-bootstrap-icons';

import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import AlertSuccessComponent from '../components/AlertSuccessComponent';
import LoadingComponent from '../components/LoadingComponent';
import PackagingDetailsComponent from '../components/PackagingDetailsComponent';
import AuthErrorComponent from '../components/AuthErrorComponent';
import PackagingDetailsHelpComponent from '../components/PackagingDetailsHelpComponent';
import ConfirmModalComponent from '../components/ConfirmModalComponent';
import ProductSearchComponent from '../components/ProductSearchComponent';

import {
    NO_USER_FOUND,
    FAILED_AUTHENTICATE_TOKEN,
  } from "../constants/ApiResult";

const axios = require('axios').default;

class SupplierInventory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            authError:false,
            apiErrorMessage:'',
            isLoading:false,
            state:1,
            goodsId:0,
            goodsCodeSearch:'',
            goodsName:'',
            goodsNameAlias:'',
            goodsCode:'',
            isConvert:false,
            isWeigh:false,
            unitIdWeigh:0,
            goodsStep:1,
            goodsUnitPrice:0.00,
            step:0,
            sortValue:0,
            unitId:0,
            view:'inventory',
            unitsData:[],
            unitsAPI:false,
            goodsInfoData:[],
            goodsInfoAPI:false,
            goodsItemsData:[],
            goodsItemsDataAPI:false,
            //goodsItem:0,
            goodsItemsAllData:[],
            goodsItemsAllDataAPI:false,
            itemMainTypeId:0,
            itemTypeId:0,
            itemId:0,
            isErrorMessage:[],
            packaging:[{
                state:1,
                barcode:'',
                unitPrice:0,
                goodsFormatNum:0.00,
                goodsFormatId:0,
                unitId:0,
                goodsFormatName:''
            }],
            isConfirmModal:false,
            isConfirmRemoveModal:false,
            isConfirmProductStateModal:false
        }
    }

    componentDidMount() {
        this.getUnitsAPI();
        this.getGoodsInfoAPI();
        this.getGoodsAllItemsAPI();
    }

/*
API
*/

    isFailAPI = (result) => {
        if([NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(result) > -1) {
            this.setState({
                authError:true,
                isLoading:false
            });
            return true;
        }
        return false;
    }

    handleErrorAPI = (error, message) => {
        console.error(error.response);
        this.setState({
            apiErrorMessage:message,
            isLoading:false
        });
    }

// (GET) Units
    getUnitsAPI = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/getUnits`,{
            params: {
            },
            headers:{
                'Authorization': `Basic ${this.props.auth.token}` 
            }
        })
        .then( (response) => {
            if(this.isFailAPI(response.data.result)) {
                return;
            }

            if(response.data.data.length) {
                this.setState({
                    unitsAPI:true,
                    unitsData:response.data.data,
                    isLoading:false
                }, () => {
                 
                });
            } else {
                this.setState({
                    unitsAPI:true,
                }, () => {
                    this.handleErrorAPI(null,'Bad Request (400)');
                });
                
            }
        })
        .catch( (error) => {
            this.setState({
                getUnitsAPI:true
            }, () => {
                this.handleErrorAPI(error,'Internal Server Error (500)');
            });
        });  
    }

// (GET) GoodsInfo
    getGoodsInfoAPI = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/getGoodsInfoList`,{
            params: {
                supplierId:this.props.auth.supplierId,
                branchId:0
            },
            headers:{
                'Authorization': `Basic ${this.props.auth.token}` 
            }
        })
        .then( (response) => {
            if(this.isFailAPI(response.data.result)) {
                return;
            }
            if(response.data.data) {
                this.setState({
                    goodsInfoData:response.data.data,
                    goodsInfoAPI:true
                });
            } else {
                this.setState({
                    goodsInfoAPI:true
                }, () => {
                    this.handleErrorAPI(null,'Bad Request (400)');
                });
            }
        })
        .catch( (error) => {
            this.setState({
                goodsInfoAPI:true
            }, () => {
                this.handleErrorAPI(error,'Internal Server Error (500)');
            });
        });  
    }

// (GET) Goods All Items (Categories)
getGoodsAllItemsAPI = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/getGoodsAllItems`,{
        params: {
        },
        headers:{
            'Authorization': `Basic ${this.props.auth.token}` 
        }
    })
    .then( (response) => {
        if(this.isFailAPI(response.data.result)) {
            return;
        }

        if(response.data.data.length) {
            this.setState({
                goodsAllItemsData:response.data.data,
                goodsAllItemsAPI:true
            });

        } else {
            this.setState({
                goodsAllItemsAPI:true
            }, () => {
                this.handleErrorAPI(null,'Bad Request (400)');
            });
        }
    })
    .catch( (error) => {
        this.setState({
            goodsAllItemsAPI:true
        }, () => {
            this.handleErrorAPI(error,'Internal Server Error (500)');
        });
    });  
}

// (POST) Submit API

    postSubmitAPI = () => {

        let sortVal = this.state.sortValue ? this.state.sortValue : 0;

        let data = {
            "state": this.state.state,
            "goodsId": this.state.goodsId,
            "goodsName": this.state.goodsName,
            "goodsNameAlias": this.state.goodsNameAlias,
            "goodsCode": this.state.goodsCode,
            "itemId": this.state.itemId,
            "isConvert": this.state.isConvert,
            "unitIdWeigh": this.state.unitIdWeigh,
            "sortVal": parseInt(sortVal),
            "unitId":this.state.unitId,
            "barcode":this.state.packaging[0].barcode,
            "sellPrice":this.state.packaging[0].unitPrice,
            "goodsFormatNum":this.state.packaging[0].goodsFormatNum,
            "goodsFormatName":this.state.packaging[0].goodsFormatName,
            "goodsFormat":this.state.packaging.filter( (obj) => obj.goodsFormatId !== 0 )
        };

        let service = "";
        let payload = {
            data:data,
            supplierId:this.props.auth.supplierId,
            env:process.env.REACT_APP_ENV
        };
        let headers = {
            Authorization: 'Basic ' + this.props.auth.token
        };

        if(this.state.goodsCodeSearch) {
            service = axios.put(`${process.env.REACT_APP_API_URL}/api/supplier/product/`,payload,{
            headers:headers
            });
        } else {
            service = axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/product/`,payload,{
                headers:headers
                });
        }

        const inventoryBranchProductMapping = this.props.auth.suppliersConfig.ui.supplierAdmin.inventoryBranchProductMapping;
        service.then( (response) => {
            // Map product to order template
            if(!this.state.goodsCodeSearch && inventoryBranchProductMapping) {
                let data = {
                    "poId": this.props.auth.suppliersConfig.poId,
                    "goodsId": response.data.data[0].goodsId,
                    "state": this.state.state,
                }
                let service = "";
                let payload = {
                    data:data,
                    supplierId:this.props.auth.supplierId,
                    env:process.env.REACT_APP_ENV
                };
                let headers = {
                    Authorization: 'Basic ' + this.props.auth.token
                };    
                service = axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/mapProductTemplate/`,payload,{
                    headers:headers
                    });
                service.then( (response) => {
                    this.setState({
                        view:'addSuccess',
                        isLoading:false
                    });
                })
                .catch( (error) => {
                    this.handleErrorAPI(error,'Internal Server Error (500)');
                });
            } else {
                this.setState({
                    view:'addSuccess',
                    isLoading:false
                });
            }
        })
        .catch( (error) => {
            this.handleErrorAPI(error,'Internal Server Error (500)');
        });
    }

    isLoading = () => {
        if(!this.state.unitsAPI || !this.state.goodsInfoAPI || !this.state.goodsAllItemsAPI) {
            return true;
        }
        return false;
    }

/*
Helper Classes
*/

    toFixed = (num, toFixed) => {
        if(num) {
            let split = num.toString().split('.');
            let len;
            if(split[1]) {
                len = split[1].length;
            }
            if(len > toFixed) {
                return parseFloat(num).toFixed(toFixed);
            }
            return num;
        }
        return num;
    }

/*
Product Search
*/

resetGoodState = () => {
    this.setState({
        goodsCodeSearch:'',
        goodsName:'',
        goodsNameAlias:'',
        goodsCode:'',
        itemMainTypeId:0,
        itemTypeId:0,
        itemId:0,
        sortValue:0,
        unitId:0,
        isConvert:false,
        isWeigh:false,
        unitIdWeigh:0,
        packaging:[{
            state:1,
            barcode:'',
            unitPrice:0,
            goodsFormatNum:0.00,
            goodsFormatId:0,
            unitId:0,
            goodsFormatName:''
        }]
    });
}

handleChangeProductSearch = (value) => {
    this.setState({
        goodsCodeSearch:!value ? '' : value,
    }, () => {
        this.resetGoodState();
    });
}

handleSelectProductSearch = (goodsCode, goodsId) => {
    this.setState({
        goodsId:goodsId,
        goodsCodeSearch:goodsCode
    }, () => {
        this.getGoodsInfo();
    });
}

getGoodsInfo = () => {
    let data = this.state.goodsInfoData.filter( (row) => row.GoodsCode === this.state.goodsCodeSearch)[0];
    // set the form states
    if(data) {
        this.setGoodsInfo(data);
    }
}

setGoodsInfo = (data) => {
    let packaging = [{
        state:1,
        barcode:data.Barcode,
        unitPrice:data.SellPrice,
        goodsFormatNum:data.GoodsFormatNum,
        goodsFormatId:0,
        unitId:this.getUnitIdByUnitName(data.GoodsFormatName),
        goodsFormatName:data.GoodsFormatName
    }];

    if(data.goodsFormatList.length > 1) {
        data.goodsFormatList.forEach( (obj, index) => {
            if(index > 0) {
                packaging.push({
                    state:1,
                    barcode:obj.Barcode,
                    unitPrice:obj.SellPrice,
                    goodsFormatNum:obj.Num,
                    goodsFormatId:obj.GoodsFormatId,
                    unitId:this.getUnitIdByUnitName(obj.GoodsFormatName),
                    goodsFormatName:obj.GoodsFormatName
                });
            }
        });
    }

    this.setState({
        goodsName:data.GoodsName,
        goodsNameAlias:data.GoodsNameAlias,
        goodsCode:data.GoodsCode,
        itemMainTypeId:data.ItemMainTypeId,
        itemTypeId:data.ItemTypeId,
        itemId:data.ItemId,
        sortValue:data.sortVal,
        unitId:data.UnitId,
        isConvert:data.isConvert ? true: false,
        isWeigh:data.UnitIdWeigh ? true : false,
        unitIdWeigh:data.UnitIdWeigh,
        packaging:packaging
    });
}


/*
Product Details
*/

// Product Name
handleChangeProductName = (e) => {
    this.setState({
        goodsName:e.target.value
    });
}

// Product Alias
handleChangeProductAlias = (e) => {
    this.setState({
        goodsNameAlias:e.target.value
    }); 
}

// Product Code
handleChangeProductCode = (e) => {
    let goodsCode = e.target.value;
    this.setState({
        goodsCode:goodsCode,
        isErrorProductCode:false
    }, (e) => {
        if(!this.state.goodsCodeSearch && this.state.goodsInfoData.findIndex( (obj) => obj.GoodsCode.toLowerCase() === goodsCode.toLowerCase()) > -1) {
            this.setState({
                isErrorProductCode:true
            });
        }
    }); 
}

// Barcode
handleOnChangeBarcode = (value, index) => {
    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    packaging[index].barcode = value;
    this.setState({
        packaging:packaging
    });
}

// Unit Price
handleOnChangeUnitPrice = (value, index) => {
    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    packaging[index].unitPrice = value;
    this.setState({
        packaging:packaging
    });
}

// Step
handleChangeProductStep = (e) => {
    let value = e.target.value;
    if(value < 1) {
        value = 1;
    }
    this.setState({
        goodsStep:value
    });
}

// Sort Value
handleChangeSortValue = (e) => {
    let value = parseInt(e.target.value);
    if(value < 1) {
        value = 0;
    }
    this.setState({
        sortValue:value
    });
}

// Goods Items

getItemMainTypes = () => {
    let filter = this.state.goodsAllItemsData.filter( (row) => row.ItemMainTypeId === this.state.itemMainTypeId )[0];
    if(filter) {
        return filter;
    }
    return [];
}

getItemTypes = () => {
    let data = this.getItemMainTypes();
    if(data) {
        let filter = data.ItemType.filter( (row) => row.ItemTypeId === this.state.itemTypeId )[0];
        if(filter) {
            return filter;
        }
    }
    return [];
}

getMainProductCategoryTitle = () => {
    if(this.state.itemMainTypeId) {
        let data = this.getItemMainTypes();
        if(data) {
            return data.ItemMainTypeName;
        }
    }
    return "Select Category";
}

getSubProductCategoryTitle = () => {
    if(this.state.itemMainTypeId && this.state.itemTypeId) {
        let data = this.getItemTypes();
        if(data) {
            return data.ItemTypeName;
        }
    }
    return "Select Category";
}

getProductCategoryTitle = () => {
    if(this.state.itemId) {
        let data = this.getItemTypes();
        if(data && data.Item) {
            let filter = data.Item.filter( (row) => row.ItemId === this.state.itemId)[0];
            if(filter) {
                return filter.ItemName;
            }
        }
    }
    return "Select Category";
}

handleOnSelectMainProductCategory = (value) => {
    this.setState({
        itemMainTypeId:parseInt(value),
        itemTypeId:0
    });
}

handleOnSelectSubProductCategory = (value) => {
    this.setState({
        itemTypeId:parseInt(value),
        itemId:0
    });
}

handleOnSelectProductCategory = (value) => {
    this.setState({
        itemId:parseInt(value)
    });
}

htmlDropDownMainProductCategory = () => {
    return this.state.goodsAllItemsData.map( (row, index) => {
        return <Dropdown.Item eventKey={row.ItemMainTypeId} key={index}>{row.ItemMainTypeName}</Dropdown.Item>
    });
}

htmlDropDownSubProductCategory = () => {
    if(this.state.itemMainTypeId) {
        let data = this.getItemMainTypes();
        if(data.ItemType) {
            return data.ItemType.map( (row, index) => {
                return <Dropdown.Item eventKey={row.ItemTypeId} key={index}>{row.ItemTypeName}</Dropdown.Item>
            });
        }
    } else {
        return;
    }
}

htmlDropDownProductCategory = () => {
    if(this.state.itemMainTypeId && this.state.itemTypeId) {
        let data = this.getItemTypes();
        if(data) {
            return data.Item.map( (row, index) => {
                return <Dropdown.Item eventKey={row.ItemId} key={index}>{row.ItemName}</Dropdown.Item>
            });
        }
    } else {
        return;
    }
}

/*
Unit Qty
*/

    handleOnChangeUnitQty = (value, index) => {
        let packaging = JSON.parse(JSON.stringify(this.state.packaging));
        packaging[index].goodsFormatNum = value;
        this.setState({
            packaging:packaging
        });
    }


/*
Unit Name
*/

/*
handleOnSelectUnitName = (value, name, index) => {
    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    packaging[index].unitId = value;
    this.setState({
        packaging:packaging
    });
}
*/

getUnitIdByUnitName = (unitName) => {
    let filter = this.state.unitsData.filter( (obj) => obj.UnitName === unitName )[0];
    if(filter) {
        return filter.UnitId;
    } else {
        return 0;
    }
}

getUnitTitle = (value) => {
    let filter = this.state.unitsData.filter( (unit) => unit.UnitId === parseInt(value) )[0];
    if(filter) {
        return filter.UnitName;
    }
    return "Select Unit Name";
}

handleOnSelectUnitName =  (value) => {
    this.setState({
        unitId:value
    });
}

htmlDropDownUnitName = () => {
    return this.state.unitsData.map( (unit, index) => {
        return <Dropdown.Item eventKey={unit.UnitId} key={index}>{unit.UnitName}</Dropdown.Item>
    });
}

getUnitsData = (isFilter) => {
    // check to see if packaging exists, exclude from unitsData
    if(isFilter) {
        let data = this.state.unitsData.filter( (obj) => {
            let index = this.state.packaging.findIndex( (packaging) => packaging.goodsFormatId === obj.UnitId );
            if(index === -1) {
                return true;
            }
            return false;
        });
        return data;
    } else {
        return this.state.unitsData;
    }
}

/*
Product Specs - Weighing
*/

handleOnSelectWeighingUnit = (value) => {
    this.setState({
        unitIdWeigh:value
    });
}

/*
Packaging
*/

handleOnSelectPackaging = (value, name, index) => {

    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    //packaging[index].goodsFormatId = parseInt(value);
    packaging[index].unitId = parseInt(value);
    packaging[index].goodsFormatName = name;

    this.setState({
        packaging:packaging
    });
}

handleAddPackaging = () => {
    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    packaging.push({
        state:1,
        barcode:'',
        goodsFormatNum:0,
        goodsFormatId:null,
        unitId:0,
        unitPrice:0,
        goodsFormatName:''
    });
    this.setState({
        packaging:packaging
    });
}

handleTogglePackaging = (state, index) => {
    this.setState({
        isConfirmRemoveModal:true,
        toggleState:state,
        toggleIndex:index
    });
}

doTogglePackaging = () => {
    let packaging = JSON.parse(JSON.stringify(this.state.packaging));
    if(this.state.toggleIndex > 0) {

        packaging[this.state.toggleIndex].state = !this.state.toggleState ? 1 : 0;
        
        this.setState({
            packaging:packaging
        });
    } else {
        alert('Cannot remove default packaging');
    }
}

isPackagingDisabled = () => {
    // check all packaging is enabled
    let disabled = false;
    this.state.packaging.forEach( (packing) => {
        if(!packing.goodsFormatNum || !packing.goodsFormatName) {
            disabled = true;
        }
    });
    return disabled;
}


/*
Confirm
*/

    isConfirmDisabled = () => {
        // temporarily return false
        // return false;

        if(!this.state.goodsName ||
            !this.state.goodsCode ||
            !this.state.itemId || 
            !this.state.unitId ||
            this.isPackagingDisabled() ||
            this.state.isErrorProductCode
        ) {
            return true;
        }
        return false;
    }

    handleOnConfirm = () => {
        this.setState({
           isConfirmModal:true
        });
    }

    htmlConfirmModal = () => {
        return (
            <Modal 
                show={this.state.isConfirmModal} 
                onHide={this.handleCloseConfirmModal}
                size="lg"
            >    
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.goodsCodeSearch ? "Supplier Inventory Update (Confirm)" : "Supplier Inventory Add (Confirm)"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.goodsCodeSearch &&
                    <div className="mt-4">
                        <div className="font-weight-bold">Product State: </div>
                        {this.state.state ? "Enabled" : "Disabled"}
                    </div>
                    }
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Name: </div>
                        {this.state.goodsName}
                    </div>
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Alias: </div>
                        {this.state.goodsNameAlias}
                    </div>
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Code: </div>
                        {this.state.goodsCode}
                    </div>
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Category: </div>
                
                        {`${this.getMainProductCategoryTitle(this.state.itemMainTypeId)} - 
                        ${this.getSubProductCategoryTitle(this.state.itemTypeId)} - 
                        ${this.getProductCategoryTitle(this.state.itemId)}`}
                
                    </div>
                    {this.state.isConvert &&
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Unit Convert:</div>
                        Yes
                    </div>
                    }
                    {this.state.isWeigh &&
                    <div className="mt-4">
                        <div className="font-weight-bold">Product Weighing:</div>
                        {this.getUnitTitle(this.state.unitIdWeigh)}
                    </div>
                    }

                    {/*
                    <div className="mt-4">
                        <div className="font-weight-bold">Step: </div>
                        {this.state.goodsStep}
                    </div>
                    */}

                    <div className="mt-4">
                        <div className="font-weight-bold">Sort Value: </div>
                        {this.state.sortValue ? this.state.sortValue : 0}
                    </div>

                    {/*
                    <div className="mt-4">
                        <div className="font-weight-bold">Unit Price: </div>
                        {this.toFixed(this.state.goodsUnitPrice,10)}
                    </div>
                    */}

                    <div className="mt-4">
                        <div className="font-weight-bold">Unit Name: </div>
                        {this.getUnitTitle(this.state.unitId)}
                    </div>
                    <div className="mt-4">
                        <span className="font-weight-bold">Default Packaging</span>
                        <Table bordered hover className="mt-2" size="sm">
                        <thead>
                            <tr>
                                <th width="25%">Barcode</th>
                                <th width="25%">Unit Price</th>    
                                <th width="25%">Unit Quantity</th>
                                <th width="25%">Packaging</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{this.state.packaging[0].barcode}</td>
                                <td>{this.state.packaging[0].unitPrice}</td>
                                <td>{this.state.packaging[0].goodsFormatNum}</td>
                                <td>{this.getUnitTitle(this.state.packaging[0].unitId)}</td>
                            </tr>
                        </tbody>
                        </Table>

                        {this.state.packaging.length > 1 &&
                        <>
                        <span className="font-weight-bold">Supplementary Packaging</span>
                        <Table bordered hover className="mt-2" size="sm">
                        <thead>
                            <tr>
                                <th width="25%">Barcode</th>
                                <th width="25%">Unit Price</th>  
                                <th width="25%">Unit Quantity</th>
                                <th width="25%">Packaging</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.packaging.map( (packing, index) => {
                                if(!packing.state) {
                                    return ""
                                }
                               return (
                                   index > 0 &&
                                    <tr>
                                        <td>{packing.barcode}</td>
                                        <td>{packing.unitPrice ? packing.unitPrice : 0}</td>
                                        <td>{packing.goodsFormatNum}</td>
                                        <td>{this.getUnitTitle(packing.unitId)}</td>
                                    </tr>
                               )
                            })}
                        </tbody>
                        </Table>
                        </>
                        }
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={this.handleCloseConfirmModal}>
                        Back
                    </Button>
                    <Button 
                        variant="primary"
                        onClick={this.handleOnSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleCloseConfirmModal = () => {
        this.setState({
            isConfirmModal:false
        });
    }

/*
Submit
*/
    handleOnSubmit = () => {
        this.setState({
            isLoading:true
        }, () => {
            this.postSubmitAPI();
        });
    }

/*
Add Inventory Success
*/

    handleAddSuccessGoBack = () => {
        this.setState({
            isConfirmModal:false,
            view:'inventory',
            goodsInfoAPI:false
        }, () => {
            this.getGoodsInfoAPI();
            this.resetGoodState()
        });
    }

    handleAddSuccessGoBranchMapping= () => {
        this.props.history.push({
            pathname:'/supplier-inventory-branch-product-mapping',
            state: {
                goodsCode:this.state.goodsCode,
                goodsFormatNum:this.state.goodsFormatNum,
                unitId:this.state.unitId,
                unitName:this.state.unitName,
                goodsFormatId:this.state.goodsFormatId,
                goodsFormatName:this.state.goodsFormatName
            }
        });
    }

/*
Toggle Product State
*/

handleToggleProduct = () => {
    this.setState({
        state:!this.state.state
    });
}


/*
Render
*/
    
    render() {

        return (
            <>
            <Container fluid className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container>
                    <Row>
                        <Col xs={12} className="mt-4">
                            <h1>Supplier Inventory - Manage</h1>    
                        </Col>
                    </Row>

                    {this.state.authError
                    ?
                        <AuthErrorComponent />
                    :
                        <>
                        {this.state.isLoading || this.isLoading()
                        ?
                            <LoadingComponent />
                        :
                
                        <div className="mt-4">
                            {
                            this.state.view === "inventory"
                            ?
                                this.state.apiErrorMessage
                                ?
                                    <AlertErrorComponent label={this.state.apiErrorMessage} />
                                :
                                <>
                                    {this.state.isErrorMessage.length > 0 &&
                                        <AlertErrorComponent label={this.state.isErrorMessage.toString()} />
                                    }

                                    <div className="mt-4">
                                        <ProductSearchComponent
                                            products={this.state.goodsInfoData}
                                            goodsCode={this.state.goodsCodeSearch}
                                            handleChangeGoodsCode={(value) => this.handleChangeProductSearch(value)}
                                            handleSelectGoodsCode={(goodsCode, goodsId) => this.handleSelectProductSearch(goodsCode, goodsId)}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <span>All fields marked with <sup className="text-warning">*</sup> are required.</span>
                                    </div>

                                    {this.state.goodsCodeSearch &&
                                    <>
                                    <div className="mt-4">
                                        <span className="font-weight-bold">Product State</span>
                                    </div>

                                    <div className="mt-2">
                                        <Button variant="secondary" onClick={ () => this.setState({
                                            isConfirmProductStateModal:true
                                        })}>
                             
                                            {!this.state.state
                                            ?   
                                                <>
                                                <ToggleOff size={16} className="mb-1 me-1" />
                                                <span>Disabled</span>
                                                </>
                                            :
                                                <>
                                                <ToggleOn size={16} className="mb-1 me-1" />
                                                <span>Enabled</span>
                                                </>
                                            }
                                        </Button>
                                    </div>
                                    </>
                                    }

                                    <div className="mt-4">
                                        <span className="font-weight-bold">Product Details</span>
                                    </div>

                                    <Form className="mt-2">
                                    <Form.Group controlId="formProductName">
                                        <Form.Label>Name<sup className="text-warning">*</sup></Form.Label>
                                        <Form.Control 
                                            type="text"
                                            placeholder="Enter product name"
                                            onChange={this.handleChangeProductName}
                                            value={this.state.goodsName}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mt-3" controlId="formProductAlias">
                                        <Form.Label>Alias</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Enter product alias"
                                            onChange={this.handleChangeProductAlias}
                                            value={this.state.goodsNameAlias}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mt-3" controlId="formProductCode">
                                        <Form.Label>Code<sup className="text-warning">*</sup></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Enter product code" 
                                            onChange={this.handleChangeProductCode} 
                                            value={this.state.goodsCode}
                                        />
                                        {this.state.isErrorProductCode &&
                                        <div className="mt-3">
                                            <Alert className="bg-danger text-white">
                                                <ExclamationCircle size={16} className="mb-1 me-1" />
                                                Product code taken
                                            </Alert>
                                        </div>
                                        }
                                    </Form.Group>

                                    <Row>
                                        <Col className="mt-4">
                                            <Row>
                                                <Col xs={12}>
                                                    <span className="font-weight-bold">Product Category</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={4} className="mt-2">
                                                    <Form.Group className="mt-3" controlId="formProductCategoryPrimary">
                                                        <Form.Label>Primary</Form.Label>
                                                        <DropdownButton 
                                                            id="formProductCategoryPrimary"
                                                            title={this.getMainProductCategoryTitle(this.state.itemId)}
                                                            onSelect={this.handleOnSelectMainProductCategory}
                                                            value={this.state.itemId}
                                                            variant="secondary"
                                                        >
                                                            {this.htmlDropDownMainProductCategory()}  
                                                        </DropdownButton>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={12} md={4} className="mt-2">
                                                    <Form.Group className="mt-3" controlId="formProductCategorySecondary">
                                                        <Form.Label>Secondary</Form.Label>
                                                        <DropdownButton 
                                                            id="formProductCategorySecondary"
                                                            title={this.getSubProductCategoryTitle(this.state.itemId)}
                                                            onSelect={this.handleOnSelectSubProductCategory}
                                                            value={this.state.itemId}
                                                            variant="secondary"
                                                        >
                                                            {this.htmlDropDownSubProductCategory()}  
                                                        </DropdownButton>
                                                    </Form.Group>    
                                                </Col>
                                                <Col sm={12} md={4} className="mt-2">
                                                    <Form.Group className="mt-3" controlId="formProductCategory">
                                                        <Form.Label>Product<sup className="text-warning">*</sup></Form.Label>
                                                        <DropdownButton 
                                                            id="formProductCategory"
                                                            title={this.getProductCategoryTitle(this.state.itemId)}
                                                            onSelect={this.handleOnSelectProductCategory}
                                                            value={this.state.itemId}
                                                            variant="secondary"
                                                        >
                                                            {this.htmlDropDownProductCategory()}  
                                                        </DropdownButton> 
                                                    </Form.Group>  
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Form.Group className="mt-4" controlId="formProductUnitConvert">
                                        <Form.Label className="font-weight-bold">Product Specifications</Form.Label>
                                        <Form.Check 
                                            type="checkbox"
                                            id="product-unit-convert"
                                            label="Product Unit Convert"
                                            className="mt-2"
                                            onClick={() => this.setState({
                                                isConvert:!this.state.isConvert,
                                                isWeigh:false,
                                                unitIdWeigh:0
                                            })}
                                            checked={this.state.isConvert && !this.state.isWeigh}
                                        />
                                        <Form.Check 
                                            type="checkbox"
                                            id="product-weighing"
                                            label="Product Weighing"
                                            className="mt-2"
                                            onClick={() => this.setState({
                                                isWeigh:!this.state.isWeigh,
                                                isConvert:false
                                            })}
                                            checked={this.state.isWeigh && !this.state.isConvert}
                                        />
                                        
                                        {this.state.isWeigh &&
                                        <DropdownButton 
                                            id="dropdown-weighing-unit"
                                            title={this.getUnitTitle(this.state.unitIdWeigh)}
                                            onSelect={this.handleOnSelectWeighingUnit}
                                            value={this.state.unitIdWeigh}
                                            variant="secondary"
                                            className="mt-2"
                                        >
                                        {this.htmlDropDownUnitName()}
                                        </DropdownButton>
                                        }

                                    </Form.Group>
                                    
                                    {/*
                                    <Form.Group className="mb-3" controlId="formProductStep">
                                        <Form.Label>Step</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            placeholder="Enter product step" 
                                            onChange={this.handleChangeProductStep} 
                                            value={this.state.goodsStep}
                                        />
                                    </Form.Group>
                                    */}

                                    <Form.Group className="mt-3" controlId="formProductSortValue">
                                        <Form.Label>Sort Value</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            placeholder="Enter sort value" 
                                            onChange={this.handleChangeSortValue} 
                                            value={this.state.sortValue ? this.state.sortValue : ""}
                                        />
                                    </Form.Group>

                                    {/*
                                    <Form.Group className="mb-3" controlId="formProductUnitPrice">
                                        <Form.Label>Unit Price</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={
                                            this.state.goodsUnitPrice != "" ? this.toFixed(this.state.goodsUnitPrice, 2) : ""
                                            }
                                            placeholder={0}
                                            onChange={(e) =>
                                                this.handleChangeProductUnitPrice(
                                                    e
                                                )
                                            }
                                        />
                                    </Form.Group>
                                    */}

                                    <Form.Group className="mt-3" controlId="formProductUnitName">
                                        <Form.Label>Unit Name<sup className="text-warning">*</sup></Form.Label>
                                        <DropdownButton 
                                            id="formProductUnitName"
                                            title={this.getUnitTitle(this.state.unitId)}
                                            onSelect={this.handleOnSelectUnitName}
                                            value={this.state.goodsFormatId}
                                            variant="secondary"
                                        >
                                            {this.htmlDropDownUnitName()}
                                        </DropdownButton>
                                    </Form.Group>
                                    
                                    <div className="mt-4">
                                        <Row>
                                            <Col xs={6}>
                                                <PackagingDetailsHelpComponent
                                                placement={"right"}
                                                />
                                            </Col>
                                            <Col xs={6} className="text-end">
                                                <Button variant="secondary" onClick={ () => this.handleAddPackaging()}>
                                                    <PlusCircle size={16} className="mb-1 me-1" />
                                                    Add
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="mt-4">
                                    {
                                        this.state.packaging.map( (packing, index) => {
                                            return (
                                            <>
                                            <div className="mt-4">
                                            {index === 0 &&
                                                <span className="font-weight-bold">Default Packaging</span>
                                            }
                                            {index === 1 &&
                                                <span className="font-weight-bold">Supplementary Packaging</span>
                                            }
                                            </div>
                                            <Row>
                                                <Col sm={12} md={1} className="align-self-center mt-4">
                                                    {index > 0 &&
                                                    <Button variant="secondary" onClick={ () => this.handleTogglePackaging(packing.state, index)}>
                                                        {packing.state === 0
                                                        ?
                                                            <ToggleOff size={16} className="mb-1" />
                                                        :
                                                            <ToggleOn size={16} className="mb-1" />
                                                        }
                                                    </Button>
                                                    }
                                                </Col>
                                                <Col sm={12} md={11} className="mt-4">
                                                <PackagingDetailsComponent
                                                    index={index}
                                                    barcode={packing.barcode}
                                                    unitsData={this.getUnitsData()}
                                                    packagingData={this.getUnitsData(true)}
                                                    unitPrice={packing.unitPrice}
                                                    goodsFormatNum={packing.goodsFormatNum}
                                                    unitId={packing.unitId}
                                                    goodsFormatId={packing.goodsFormatId}
                                                    handleOnChangeBarcode={(value) => this.handleOnChangeBarcode(value, index)}
                                                    handleOnChangeUnitPrice={(value) => this.handleOnChangeUnitPrice(value, index)}
                                                    handleOnChangeUnitQty={(value) => this.handleOnChangeUnitQty(value, index)}
                                                    //handleOnSelectUnitName={(value, name) => this.handleOnSelectUnitName(value, name, index)}
                                                    handleOnSelectPackaging={(value, name) => this.handleOnSelectPackaging(value, name, index)}
                                                    tip={false}
                                                    ui={{
                                                        barcode:true,
                                                        unitPrice:true,
                                                        unitQty:true,
                                                        unitName:false,
                                                        unitPacking:true
                                                    }}
                                                />
                                                </Col>
                                            </Row>
                                            </>
                                            )    
                                        })
                                    }
                                    </div>
                                    <div className="mt-4 text-end">
                                        <Button 
                                        variant="primary"
                                        disabled={this.isConfirmDisabled()}
                                        onClick={this.handleOnConfirm}
                                        >
                                            Confirm
                                        </Button>
                                    </div>

                                    </Form>
                                    {this.htmlConfirmModal()}
                                </>
                            :
                                this.state.view === 'addSuccess' &&
                                <>
                                    <AlertSuccessComponent label={this.state.goodsCodeSearch ? `Supplier Inventory Update Successful` : `Supplier Inventory Add Successful`} />

                                    
                                    <div className="mt-4">
                                        <Row>
                                            <Col xs={12} sm={6}>
                                                <Button 
                                                variant="secondary" 
                                                className="mt-4"
                                                onClick={this.handleAddSuccessGoBack}
                                                >
                                                Go Back
                                                </Button>
                                            </Col>
                                            {/*
                                            <Col xs={12} sm={6} className="mt-4 text-sm-end">
                                                <Button 
                                                variant="primary" 
                                                onClick={this.handleAddSuccessGoBranchMapping}
                                                >
                                                Yes (Product - Branch Mapping)
                                                </Button>
                                            </Col>
                                            */}
                                        </Row>
                                    </div>
                                </>
                            }
                        </div>
                        }
                        </>   
                    }

                    <ConfirmModalComponent
                        size="md"
                        title={"Supplier Inventory"}
                        body={this.state.state ? "Confirm disable product (this cannot be undone)?" : "Confirm enable product?"}
                        show={this.state.isConfirmProductStateModal}
                        handleClose={() => {
                            this.setState({
                                isConfirmProductStateModal:!this.state.isConfirmProductStateModal
                            });
                        }}
                        handleSubmit={() => {
                            this.setState({
                                isConfirmProductStateModal:false
                            }, () => {
                                this.handleToggleProduct()
                            });
                        }}
                    />

                    <ConfirmModalComponent
                        size="md"
                        title={"Supplier Inventory"}
                        body={this.state.toggleState ? "Confirm disable packaging (this cannot be undone)?" : "Confirm enable packaging?"}
                        show={this.state.isConfirmRemoveModal}
                        handleClose={() => {
                            this.setState({
                                isConfirmRemoveModal:!this.state.isConfirmRemoveModal
                            });
                        }}
                        handleSubmit={() => {
                            this.setState({
                                isConfirmRemoveModal:false
                            }, () => {
                                this.doTogglePackaging();
                            });
                        }}
                    />
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(SupplierInventory));
